import axiosconf from './axiosconf'
import global from '../globle/globle'
import store from '../store'
import axios from 'axios'

// 首页板块管理
export function homeList(blockType) {
  return axiosconf.applicationJson('/business/cms/home/list', { blockType: blockType || null })
}
export function homeAdd(payload) {
  return axiosconf.applicationJson('/business/cms/home/add', payload)
}
export function homeEdit(payload) {
  return axiosconf.applicationJson('/business/cms/home/edit', payload)
}
export function homeDelete(id) {
  return axiosconf.applicationJson('/business/cms/home/delete', { id })
}
export function homeSort(items) {
  return axiosconf.applicationJson('/business/cms/home/sort', { items })
}
export function homeToggle(id, status) {
  return axiosconf.applicationJson('/business/cms/home/toggle', { id, status })
}

// 关于我们
export function aboutGet() {
  return axiosconf.applicationJsonGet('/business/cms/about/detail')
}
export function aboutEdit(payload) {
  return axiosconf.applicationJson('/business/cms/about/edit', payload)
}

// 产品资质 - 头部（单例）
export function qualIntroGet() {
  return axiosconf.applicationJsonGet('/business/cms/qualification/intro/detail')
}
export function qualIntroEdit(payload) {
  return axiosconf.applicationJson('/business/cms/qualification/intro/edit', payload)
}

// 产品资质 - 证书列表
export function qualCertList() {
  return axiosconf.applicationJson('/business/cms/qualification/cert/list', {})
}
export function qualCertAdd(payload) {
  return axiosconf.applicationJson('/business/cms/qualification/cert/add', payload)
}
export function qualCertEdit(payload) {
  return axiosconf.applicationJson('/business/cms/qualification/cert/edit', payload)
}
export function qualCertDelete(id) {
  return axiosconf.applicationJson('/business/cms/qualification/cert/delete', { id })
}
export function qualCertSort(items) {
  return axiosconf.applicationJson('/business/cms/qualification/cert/sort', { items })
}
export function qualCertToggle(id, status) {
  return axiosconf.applicationJson('/business/cms/qualification/cert/toggle', { id, status })
}

// 图片上传：复用 /business/base/image/upload（businessFilter token 路径）
// 返回 AjaxResult.success(filename)，filename 形如 "material/xxx.jpg"
// 注意：用 axios.create 独立实例，绕开 axiosconf 全局拦截器对 POST 体的 qs.stringify
export function uploadImage(file) {
  const fd = new FormData()
  fd.append('file', file)
  const instance = axios.create({
    baseURL: global.axiosDefaultsURL,
    withCredentials: true,
    headers: { token: store.getters.tokenString },
  })
  return instance.post('/business/base/image/upload', fd)
}

// 服务器图片绝对路径前缀（imgPath + 相对路径 = 可访问 URL）
export const imageBaseUrl = global.imgPath
